import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const devConfig: ApplicationConfig = {
  apiUrl: 'https://dev-api.skin-seoul.com',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.DEV,
  sheetId: '1CNmHugwnAfmcFjMf1okeUJBsoUtFh7o-ktd7qXrcyEU',
  wpAdminUrl: 'https://dev.skin-seoul.com/wp-admin/',
  adminUrl: 'https://dev-admin.skin-seoul.work',
};
